<main class="w-full min-h-screen py-12 md:py-16" *ngIf="sizeGuide && !isLoading">
  <section class="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="text-center mb-12">
      <h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
        <span class="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-orange-500">{{ 'Tabela rozmiarów' | translate }}</span>
      </h1>
      <p class="text-gray-600 text-lg md:text-xl max-w-2xl mx-auto">{{ 'Dobierz odpowiedni rozmiar, korzystając z tabel i szczegółowych wymiarów.' | translate }}</p>
    </div>

    <!-- Tab Navigation -->
    <div class="mb-8">
      <div class="flex justify-center">
        <div class="inline-flex bg-white rounded-2xl p-2 shadow-lg border border-orange-200">
          <button
            *ngFor="let tab of sizeGuide; let i = index"
            (click)="selectTab(i)"
            class="px-6 py-3 text-sm md:text-base font-semibold rounded-xl focus:outline-none relative"
            [ngClass]="{
              'text-white bg-gradient-to-r from-orange-600 to-orange-500 shadow-lg': selectedTabIndex === i,
              'text-orange-700 hover:text-orange-800 hover:bg-orange-50': selectedTabIndex !== i
            }"
          >
            {{ tab?.title }}
            <span *ngIf="selectedTabIndex === i" class="absolute inset-0 rounded-xl bg-gradient-to-r from-orange-600 to-orange-500 -z-10"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
      <ng-container [ngSwitch]="selectedTabIndex">
        <!-- Tab 0: Shoes -->
        <div *ngSwitchCase="0" class="space-y-8">
          <div class="text-center mb-8">
            <h2 class="text-3xl font-bold text-gray-900 mb-2">{{ selectedGuide?.title }}</h2>
            <p class="text-gray-600">{{ 'Międzynarodowa tabela przeliczeniowa rozmiarów obuwia' | translate }}</p>
          </div>
          
          <div class="grid gap-8">
            <div *ngFor="let section of selectedGuide?.categories" class="bg-white rounded-2xl shadow-xl border border-orange-200 overflow-hidden">
              <div class="bg-gradient-to-r from-orange-600 to-orange-500 px-6 py-4">
                <h3 class="text-xl font-bold text-white">{{ section?.title }}</h3>
              </div>
              <div class="overflow-x-auto">
                <table class="w-full">
                  <tbody>
                    <tr
                      *ngFor="let values of section?.data; let i = index"
                      [class.bg-orange-50]="i % 2 === 0"
                      [class.bg-white]="i % 2 !== 0"
                      class="hover:bg-orange-100"
                    >
                      <td class="px-6 py-4 font-bold text-orange-700 border-r border-orange-200 whitespace-nowrap text-sm md:text-base">
                        {{ values?.label }}
                      </td>
                      <td
                        *ngFor="let value of values?.values; let index = index"
                        class="px-4 py-4 text-center text-sm md:text-base hover:bg-orange-200 hover:font-semibold"
                        [class.font-bold]="i === 0"
                        [class.text-orange-600]="i === 0"
                      >
                        {{ value }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab 1: Workwear -->
        <div *ngSwitchCase="1" class="space-y-8">
          <div class="text-center mb-8">
            <h2 class="text-3xl font-bold text-gray-900 mb-2">{{ selectedGuide?.title }}</h2>
            <p class="text-gray-600">{{ 'Tabela rozmiarów odzieży roboczej ze szczegółowymi wymiarami' | translate }}</p>
          </div>
          
          <div class="grid lg:grid-cols-2 gap-8 items-start">
            <!-- Measurement Instructions -->
            <div class="space-y-6">
              <div class="bg-white rounded-2xl shadow-xl border border-orange-200 p-6 md:p-8">
                <h3 class="text-2xl font-bold text-gray-900 mb-6 text-center">{{ 'Jak wykonać pomiary' | translate }}</h3>
                <div class="space-y-6">
                  <div
                    *ngFor="let instruction of selectedGuide?.measurementInstructions"
                    class="flex items-start space-x-4 p-4 rounded-xl bg-orange-50 border border-orange-200"
                  >
                    <div class="w-8 h-8 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span class="text-white font-bold text-sm">📏</span>
                    </div>
                    <div>
                      <h4 class="font-bold text-gray-900 mb-1">{{ instruction?.label }}</h4>
                      <p class="text-gray-600 text-sm">{{ instruction?.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Size Guide Image -->
            <div class="bg-white rounded-2xl shadow-xl border border-orange-200 p-4 md:p-6">
              <img
                class="w-full h-auto max-h-[500px] object-contain rounded-xl"
                [src]="selectedGuide?.imagepath ? selectedGuide.imagepath : '/assets/sizes-workwear.webp'"
                [alt]="'Ilustracja doboru rozmiaru' | translate"
              />
            </div>
          </div>

          <!-- Size Tables -->
          <div class="grid gap-8">
            <div *ngFor="let section of selectedGuide?.categories" class="bg-white rounded-2xl shadow-xl border border-orange-200 overflow-hidden">
              <div class="bg-gradient-to-r from-orange-600 to-orange-500 px-6 py-4">
                <h3 class="text-xl font-bold text-white">{{ section?.title }}</h3>
              </div>
              <div class="overflow-x-auto">
                <table class="w-full">
                  <tbody>
                    <tr
                      *ngFor="let values of section?.data; let i = index"
                      [class.bg-orange-50]="i % 2 === 0"
                      [class.bg-white]="i % 2 !== 0"
                      class="hover:bg-orange-100"
                    >
                      <td class="px-6 py-4 font-bold text-orange-700 border-r border-orange-200 whitespace-nowrap text-sm md:text-base">
                        {{ values?.label }}
                      </td>
                      <td
                        *ngFor="let value of values?.values"
                        class="px-4 py-4 text-center text-sm md:text-base hover:bg-orange-200 hover:font-semibold"
                        [class.font-bold]="i === 0"
                        [class.text-orange-600]="i === 0"
                      >
                        {{ value }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab 2: Gloves -->
        <div *ngSwitchCase="2" class="space-y-8">
          <div class="text-center mb-8">
            <h2 class="text-3xl font-bold text-gray-900 mb-2">{{ selectedGuide?.title }}</h2>
            <p class="text-gray-600">{{ 'Tabela rozmiarów rękawic ochronnych' | translate }}</p>
          </div>
          
          <div class="bg-white rounded-2xl shadow-xl border border-orange-200 overflow-hidden">
            <div class="bg-gradient-to-r from-orange-600 to-orange-500 px-6 py-4">
              <h3 class="text-xl font-bold text-white">{{ 'Tabela rozmiarów rękawic' | translate }}</h3>
            </div>
            <div class="overflow-x-auto">
              <table class="w-full">
                <thead>
                  <tr class="bg-orange-50">
                    <th class="px-6 py-4 font-bold text-orange-700 border-b border-orange-200 text-left">{{ 'Rozmiar' | translate }}</th>
                    <th class="px-6 py-4 font-bold text-orange-700 border-b border-orange-200 text-center">{{ 'A. Długość dłoni (mm)' | translate }}</th>
                    <th class="px-6 py-4 font-bold text-orange-700 border-b border-orange-200 text-center">{{ 'B. Obwód dłoni (mm)' | translate }}</th>
                    <th class="px-6 py-4 font-bold text-orange-700 border-b border-orange-200 text-center">{{ 'Oznaczenie koloru' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="hover:bg-orange-100">
                    <td class="px-6 py-4 font-bold text-orange-600 border-b border-orange-200">7</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">171</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">178</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">
                      <span class="inline-block w-4 h-4 bg-red-500 rounded-full"></span>
                    </td>
                  </tr>
                  <tr class="bg-orange-50 hover:bg-orange-100">
                    <td class="px-6 py-4 font-bold text-orange-600 border-b border-orange-200">8</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">182</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">203</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">
                      <span class="inline-block w-4 h-4 bg-yellow-500 rounded-full"></span>
                    </td>
                  </tr>
                  <tr class="hover:bg-orange-100">
                    <td class="px-6 py-4 font-bold text-orange-600 border-b border-orange-200">9</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">192</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">229</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">
                      <span class="inline-block w-4 h-4 bg-amber-700 rounded-full"></span>
                    </td>
                  </tr>
                  <tr class="bg-orange-50 hover:bg-orange-100">
                    <td class="px-6 py-4 font-bold text-orange-600 border-b border-orange-200">10</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">204</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">254</td>
                    <td class="px-6 py-4 text-center border-b border-orange-200">
                      <span class="inline-block w-4 h-4 bg-black rounded-full"></span>
                    </td>
                  </tr>
                  <tr class="hover:bg-orange-100">
                    <td class="px-6 py-4 font-bold text-orange-600">11</td>
                    <td class="px-6 py-4 text-center">215</td>
                    <td class="px-6 py-4 text-center">279</td>
                    <td class="px-6 py-4 text-center">
                      <span class="inline-block w-4 h-4 bg-blue-500 rounded-full"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Measurement Guide for Gloves -->
          <div class="bg-white rounded-2xl shadow-xl border border-orange-200 p-6 md:p-8">
            <h3 class="text-2xl font-bold text-gray-900 mb-6 text-center">{{ 'Jak zmierzyć dłoń' | translate }}</h3>
            
            <div class="grid lg:grid-cols-2 gap-8 items-start">
              <!-- Measurement Labels -->
              <div class="space-y-4">
                <div class="space-y-3">
                  <div class="flex items-center space-x-2">
                    <span class="font-bold text-orange-600">{{ 'A.' | translate }}</span>
                    <span class="text-gray-700">{{ 'Długość dłoni' | translate }}</span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <span class="font-bold text-orange-600">{{ 'B.' | translate }}</span>
                    <span class="text-gray-700">{{ 'Obwód dłoni' | translate }}</span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <span class="font-bold text-orange-600">{{ 'C.' | translate }}</span>
                    <span class="text-gray-700">{{ 'Kolor obszycia' | translate }}</span>
                  </div>
                </div>
              </div>

              <!-- Hand Measurement Image -->
              <div class="flex justify-center">
                <img
                  class="w-full h-auto max-h-[120px] object-contain rounded-xl"
                  src="/assets/sizes-gloves.webp"
                  [alt]="'Ilustracja pomiaru dłoni' | translate"
                />
              </div>
            </div>

            <!-- Measurement Instructions -->
            <div class="grid md:grid-cols-2 gap-6 mt-8">
              <div *ngFor="let instruction of selectedGuide?.measurementInstructions" class="text-center">
                <div class="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span class="text-white font-bold text-xl">✋</span>
                </div>
                <h4 class="font-bold text-gray-900 mb-2">{{ instruction?.label }}</h4>
                <p class="text-gray-600 text-sm">{{ instruction?.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </section>
</main>
